(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-contact"]) return;
  try {
    
  function focusContactStatus(container) {
    const status = container.querySelector('.tm-contact__status[tabindex="-1"]');
    if (status) requestAnimationFrame(() => status.focus());
  }

  focusContactStatus(document);
  document.addEventListener('shopify:section:load', (event) => focusContactStatus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-site-header')) {
    customElements.define('tm-site-header', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-dialogs-ready')) {
          this.setAttribute('data-dialogs-ready', '');

          this.querySelectorAll('[data-tm-dialog-open]').forEach((button) => {
            button.addEventListener('click', () => {
              const dialog = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
              if (!dialog) return;
              dialog.showModal();
              dialog.returnFocus = button;
              requestAnimationFrame(() => dialog.querySelector('[data-tm-dialog-focus]')?.focus());
            });
          });

          this.querySelectorAll('dialog').forEach((dialog) => {
            dialog.addEventListener('click', (event) => {
              if (event.target === dialog) dialog.close();
            });
            dialog.addEventListener('close', () => dialog.returnFocus?.focus());
          });
        }

        this.updateScrollState = () => this.toggleAttribute('data-scrolled', window.scrollY > 12);
        this.updateScrollState();
        window.addEventListener('scroll', this.updateScrollState, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateScrollState);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-main-cart"]) return;
  try {
    
  (() => {
    const initializeCart = (scope = document) => {
      scope.querySelectorAll('[data-tm-cart-root]').forEach((root) => {
        if (root.dataset.tmCartReady === 'true') return;
        root.dataset.tmCartReady = 'true';

        root.querySelectorAll('[data-tm-cart-item]').forEach((item) => {
          const input = item.querySelector('[data-tm-cart-quantity]');
          item.querySelector('[data-tm-cart-decrease]')?.addEventListener('click', () => input?.stepDown());
          item.querySelector('[data-tm-cart-increase]')?.addEventListener('click', () => input?.stepUp());
        });
      });
    };

    initializeCart();
    document.addEventListener('shopify:section:load', (event) => initializeCart(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProduct = (root) => {
      if (root.dataset.tmProductReady === 'true') return;
      root.dataset.tmProductReady = 'true';

      const variantData = root.querySelector('[data-tm-product-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const optionInputs = [...root.querySelectorAll('[data-tm-option-input]')];
      const variantInputs = [...root.querySelectorAll('[data-tm-variant-id]')];
      const submitButtons = [...root.querySelectorAll('[data-tm-submit], [data-tm-sticky-submit]')];
      const submitLabels = [...root.querySelectorAll('[data-tm-submit-label]')];
      const priceNodes = [...root.querySelectorAll('[data-tm-price]')];
      const comparePriceNodes = [...root.querySelectorAll('[data-tm-compare-price]')];
      const dynamicCheckout = root.querySelector('[data-tm-dynamic-checkout]');
      const statusNode = root.querySelector('[data-tm-status]');
      const skuWrapper = root.querySelector('[data-tm-sku-wrapper]');
      const skuNode = root.querySelector('[data-tm-sku]');
      const stickyVariant = root.querySelector('[data-tm-sticky-variant]');
      const quantityInput = root.querySelector('[data-tm-quantity-input]');
      const productForm = root.querySelector('.tm-product__form');
      const mediaTrack = root.querySelector('[data-tm-media-track]');
      const mediaItems = [...root.querySelectorAll('[data-tm-media-item]')];
      const thumbnails = [...root.querySelectorAll('[data-tm-thumbnail]')];
      const currentMediaNode = root.querySelector('[data-tm-media-current]');
      const stickyBar = root.querySelector('[data-tm-mobile-sticky]');
      const mainPurchase = root.querySelector('[data-tm-main-purchase]');
      const currency = root.dataset.currency || 'EUR';
      const locale = document.documentElement.lang || 'en';
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeMediaIndex = thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true');
      if (activeMediaIndex < 0) activeMediaIndex = 0;
      let mediaFrame;
      let variantRevision = 0;

      const moneyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      });

      const formatMoney = (amount) => moneyFormatter.format(Number(amount || 0) / 100);

      const selectedOptions = () => optionInputs
        .filter((input) => input.checked)
        .sort((first, second) => Number(first.dataset.optionPosition) - Number(second.dataset.optionPosition))
        .map((input) => input.value);

      const findVariant = () => {
        const options = selectedOptions();
        return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
      };

      const setActiveMedia = (index, shouldScroll = true) => {
        if (!mediaItems.length) return;
        activeMediaIndex = Math.max(0, Math.min(index, mediaItems.length - 1));

        mediaItems.forEach((item, itemIndex) => {
          item.classList.toggle('is-variant-media', itemIndex === activeMediaIndex);
        });

        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === activeMediaIndex;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-current', String(isActive));
        });

        if (currentMediaNode) currentMediaNode.textContent = String(activeMediaIndex + 1);

        if (shouldScroll && mediaTrack) {
          mediaTrack.scrollTo({
            left: mediaItems[activeMediaIndex].offsetLeft,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
          });
        }
      };

      const showVariantMedia = (variant) => {
        const mediaId = variant && variant.featured_media ? String(variant.featured_media.id) : '';
        if (!mediaId) return;
        const mediaIndex = mediaItems.findIndex((item) => item.dataset.mediaId === mediaId);
        if (mediaIndex >= 0) setActiveMedia(mediaIndex);
      };

      const updateOptionLabels = () => {
        optionInputs.filter((input) => input.checked).forEach((input) => {
          const label = root.querySelector(`[data-tm-option-selected="${input.dataset.optionPosition}"]`);
          if (label) label.textContent = input.value;
        });
      };

      const updateQuantityRules = (variant) => {
        if (!quantityInput || !variant || !variant.quantity_rule) return;
        const rule = variant.quantity_rule;
        const minimum = Number(rule.min || 1);
        const increment = Number(rule.increment || 1);
        quantityInput.min = String(minimum);
        quantityInput.step = String(increment);
        if (rule.max === null || rule.max === undefined) {
          quantityInput.removeAttribute('max');
        } else {
          quantityInput.max = String(rule.max);
        }
        if (Number(quantityInput.value) < minimum) quantityInput.value = String(minimum);
      };

      const applyVariant = (variant) => {
        const exists = Boolean(variant);
        const available = exists && variant.available;
        const label = available
          ? root.dataset.labelAdd
          : exists
            ? root.dataset.labelSoldOut
            : root.dataset.labelUnavailable;

        variantInputs.forEach((input) => {
          input.value = exists ? variant.id : '';
        });

        submitButtons.forEach((button) => {
          button.disabled = !available;
        });

        if (dynamicCheckout) dynamicCheckout.hidden = !available;

        submitLabels.forEach((node) => {
          node.textContent = label;
        });

        if (statusNode) {
          statusNode.textContent = available
            ? root.dataset.labelInStock
            : exists
              ? root.dataset.labelSelectedSoldOut
              : root.dataset.labelChooseVariant;
        }

        if (!exists) return;

        priceNodes.forEach((node) => {
          node.textContent = formatMoney(variant.price);
        });

        comparePriceNodes.forEach((node) => {
          const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          node.hidden = !showCompare;
          node.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
        });

        if (skuWrapper && skuNode) {
          skuWrapper.hidden = !variant.sku;
          skuNode.textContent = variant.sku || '';
        }

        if (stickyVariant) stickyVariant.textContent = variant.public_title || variant.title;
        updateQuantityRules(variant);
        showVariantMedia(variant);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      const updateVariant = () => {
        variantRevision += 1;
        const currentRevision = variantRevision;
        updateOptionLabels();
        const variant = findVariant();
        const update = () => {
          if (currentRevision !== variantRevision) return;
          applyVariant(variant);
        };
        if (document.startViewTransition && !prefersReducedMotion.matches) {
          try {
            document.startViewTransition(update);
          } catch (error) {
            update();
          }
        } else {
          update();
        }
      };

      optionInputs.forEach((input) => {
        input.addEventListener('click', (event) => event.stopPropagation());
        input.addEventListener('change', (event) => {
          event.stopPropagation();
          updateVariant();
        });
      });

      root.querySelector('[data-tm-quantity-decrease]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        quantityInput.stepDown();
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

      root.querySelector('[data-tm-quantity-increase]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        quantityInput.stepUp();
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => setActiveMedia(Number(thumbnail.dataset.mediaIndex)));
      });

      root.querySelector('[data-tm-media-previous]')?.addEventListener('click', () => {
        setActiveMedia(activeMediaIndex - 1);
      });

      root.querySelector('[data-tm-media-next]')?.addEventListener('click', () => {
        setActiveMedia(activeMediaIndex + 1);
      });

      mediaTrack?.addEventListener('scroll', () => {
        window.cancelAnimationFrame(mediaFrame);
        mediaFrame = window.requestAnimationFrame(() => {
          const nearestIndex = mediaItems.reduce((nearest, item, index) => {
            const currentDistance = Math.abs(item.offsetLeft - mediaTrack.scrollLeft);
            const nearestDistance = Math.abs(mediaItems[nearest].offsetLeft - mediaTrack.scrollLeft);
            return currentDistance < nearestDistance ? index : nearest;
          }, 0);
          setActiveMedia(nearestIndex, false);
        });
      }, { passive: true });

      root.querySelector('[data-tm-sticky-submit]')?.addEventListener('click', () => {
        if (productForm) productForm.requestSubmit();
      });

      productForm?.addEventListener('submit', (event) => {
        const variant = findVariant();
        if (!variant || !variant.available) {
          event.preventDefault();
          return;
        }
        variantInputs.forEach((input) => {
          input.value = variant.id;
        });
      }, { capture: true });

      const updateStickyBar = () => {
        if (!stickyBar || !mainPurchase) return;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const purchasePassed = mainPurchase.getBoundingClientRect().bottom < 0;
        const visible = isMobile && purchasePassed;
        stickyBar.classList.toggle('is-visible', visible);
        stickyBar.setAttribute('aria-hidden', String(!visible));
      };

      window.addEventListener('scroll', updateStickyBar, { passive: true });
      window.addEventListener('resize', updateStickyBar);
      updateStickyBar();

      window.requestAnimationFrame(() => setActiveMedia(activeMediaIndex));

    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-tm-product-root]').forEach(initializeProduct);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadRecommendations = (loader) => {
      if (loader.dataset.loading === 'true') return;
      loader.dataset.loading = 'true';

      fetch(loader.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = documentFragment.querySelector('[data-tm-recommendations-ready]');
          if (recommendations) {
            loader.replaceWith(recommendations);
          } else {
            loader.remove();
          }
        })
        .catch(() => loader.remove());
    };

    const initializeRecommendations = (scope = document) => {
      scope.querySelectorAll('[data-tm-recommendations-loader]').forEach((loader) => {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            loadRecommendations(loader);
          }, { rootMargin: '300px 0px' });
          observer.observe(loader);
        } else {
          loadRecommendations(loader);
        }
      });
    };

    initializeRecommendations();
    document.addEventListener('shopify:section:load', (event) => initializeRecommendations(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
